import React from 'react';
import { useSelector } from 'react-redux';

import { GlobalState } from 'reducers/stateTypes';
import NotificationSettingsModal from 'components/Common/NotificationSettingsModal';
import ContactNoteFromEmailModal from 'views/ContactNoteFromEmailModal/ContactNoteFromEmailModal';
import EditPartnerHistoryModal from 'views/EditHistory/EditPartnerHistoryModal';
import RejectWithdrawDialog from 'views/PartnerTabs/RejectWithdrawDialog/RejectWithdrawDialog';
import RevisionHistoryModal from 'views/Modals/RevisionHistoryModal';
import BrRevisionHistoryModal from 'views/Modals/BrRevisionHistoryModal';
import GDPRModal from 'views/PartnerTabs/GdprModal';
import GdprDataRemovalModal from 'views/PartnerTabs/GdprDataRemovalModal';
import WarningDialog from 'components/Common/WarningDialog';
import ReassignRmModal from 'views/PartnerTabs/ReassignRmModal';
import DisableBrModal from 'views/BrTabs/DisableBrModal';
import RejectWithdrawBrModal from 'views/BrTabs/RejectWithdrawBrModal';
import SuccessDialog from 'components/Common/SuccessDialog/SuccessDialog';
import ClientReadinessModal from 'views/ClientReadiness/components/ClientReadinessModal';
import { JBErrorModalWrapper } from 'components/Common/JBErrorModalWrapper';
import KycAttestationModal from 'views/BrTabs/KycAttestationModal';
import { CoverageDomicileApprovalModal } from 'views/BrTabs/CoverageDomicileApprovalModal';

const modalComponentLookupTable: any = {
  ContactNoteFromEmailModal,
  DisableBrModal,
  EditPartnerHistoryModal,
  JBErrorModalWrapper,
  GdprDataRemovalModal,
  GDPRModal,
  ClientReadinessModal,
  CoverageDomicileApprovalModal,
  KycAttestationModal,
  NotificationSettingsModal,
  ReassignRmModal,
  RejectWithdrawDialog,
  RejectWithdrawBrModal,
  RevisionHistoryModal,
  BrRevisionHistoryModal,
  WarningDialog,
  SuccessDialog,
};

const selectCurrentModals = (state: GlobalState) => state.modal;

const ModalManager = () => {
  const currentModals = useSelector(selectCurrentModals);

  const renderedModals = currentModals.map((modalDescription, index) => {
    const { modalType, modalProps = {} } = modalDescription;
    const ModalComponent = modalComponentLookupTable[modalType];

    return <ModalComponent {...modalProps} key={modalType + index} />;
  });

  return <span>{renderedModals}</span>;
};

export { ModalManager };
